import React, { useCallback, useState } from 'react'
import SearchModal from './../SearchModal'


import { useAuth } from './../../../context/Auth'
import { useLayout } from './../../../context/Layout'
import { mensagemErro, ModalEmpty, Icon } from './../../Layout'

import { useHistory } from 'react-router-dom'

import api from './../../../api'

function Header({
    router, // Router usada para realizar a pesquisa
    setData, // Data será usada para o retorno da pesquisa
    onSearchCallback, // function de callback quando existe a necessidade de chamar o search de outra tela
}) {

    const history = useHistory()

    const { getUser, removeUser } = useAuth()
    const { isScreenLogin, setOpenMenu, openMenu, setLoadFull } = useLayout()
    const usuario = getUser()
    const [showLogoutModal, setShowLogoutModal] = useState(false)

    function onSair() {
        setShowLogoutModal(true)
    }

    async function confirmSair() {
        setLoadFull(true)

        try {
            const resp = await api.get('logoff')

            if (resp.data?.erro) {
                console.log(resp.data.erro.message)
            }
        } catch (error) {
            console.error('Erro ao fazer logoff:', error)
        }

        removeUser()
        window.location.href = '/'
    }

    function Notificacao() {
        return (
            <li className="dropdown notification-list">
                <a className="nav-link dropdown-toggle arrow-none waves-light waves-effect" data-toggle="dropdown" href="#" role="button"
                    aria-haspopup="false" aria-expanded="false">
                    <i className="dripicons-bell noti-icon"></i>
                    <span className="badge badge-danger badge-pill noti-icon-badge">2</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right dropdown-lg">
                    <h6 className="dropdown-item-text">
                        Notifications (18)
                    </h6>
                    <div className="slimscroll notification-list">
                        <a href="#!" className="dropdown-item notify-item active">
                            <div className="notify-icon bg-success"><i className="mdi mdi-cart-outline"></i></div>
                            <p className="notify-details">Your order is placed<small className="text-muted">Dummy text of the printing and typesetting industry.</small></p>
                        </a>
                        <a href="#!" className="dropdown-item notify-item">
                            <div className="notify-icon bg-warning"><i className="mdi mdi-message"></i></div>
                            <p className="notify-details">New Message received<small className="text-muted">You have 87 unread messages</small></p>
                        </a>
                        <a href="#!" className="dropdown-item notify-item">
                            <div className="notify-icon bg-info"><i className="mdi mdi-glass-cocktail"></i></div>
                            <p className="notify-details">Your item is shipped<small className="text-muted">It is a long established fact that a reader will</small></p>
                        </a>
                        <a href="#!" className="dropdown-item notify-item">
                            <div className="notify-icon bg-primary"><i className="mdi mdi-cart-outline"></i></div>
                            <p className="notify-details">Your order is placed<small className="text-muted">Dummy text of the printing and typesetting industry.</small></p>
                        </a>
                        <a href="#!" className="dropdown-item notify-item">
                            <div className="notify-icon bg-danger"><i className="mdi mdi-message"></i></div>
                            <p className="notify-details">New Message received<small className="text-muted">You have 87 unread messages</small></p>
                        </a>
                    </div>
                    <a href="#!" className="dropdown-item text-center text-primary">
                        View all <i className="fi-arrow-right"></i>
                    </a>
                </div>
            </li>
        )
    }

    function MenuPerfil() {
        return (
            <li className="dropdown">
                <a className="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown" href="#!" role="button" aria-haspopup="false" aria-expanded="false">
                    <img src={usuario?.avatar} alt="profile-user" className="rounded-circle" />
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                    {/* <a href='#!' className="dropdown-item"><i className="dripicons-lock text-muted mr-2"></i> Alterar Senha</a> */}
                    {/* <div className="dropdown-divider"></div> */}
                    <a onClick={onSair} className="dropdown-item" href="#!"><i className="dripicons-exit text-muted mr-2"></i> Sair</a>
                </div>
            </li>
        )
    }

    function CloseMenu() {
        return (
            <li>
                <button className="button-menu-mobile nav-link waves-effect waves-light" onClick={() => setOpenMenu(!openMenu)}>
                    <i className="dripicons-menu nav-icon"></i>
                </button>
            </li>
        )
    }

    function Search() {
        const [searchOpen, setSearchOpen] = useState(false)

        const handleSearch = useCallback(async (pesquisaText) => {
            if (router) {
                setLoadFull(true)
                let resp = null

                if (pesquisaText)
                    resp = await api.post(`${router}/pesquisa`, { pesquisa: pesquisaText })
                else
                    resp = await api.post(`${router}/dados`, { page: 1 })

                if (setData)
                    setData(resp.data)

                setLoadFull(false)
            }
        }, [router, setData, setLoadFull])

        // Shortcut listener
        React.useEffect(() => {
            const handleKeyDown = (e) => {
                if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                    e.preventDefault()
                    setSearchOpen(true)
                }
            }
            window.addEventListener('keydown', handleKeyDown)
            return () => window.removeEventListener('keydown', handleKeyDown)
        }, [])


        return (
            <>
                <li className="hide-phone app-search">
                    <div className="header-search-trigger" onClick={() => setSearchOpen(true)}>
                        <i className="ti-search"></i>
                        <span>Pesquisar...</span>
                        <span className="shortcut">⌘K</span>
                    </div>
                </li>

                <SearchModal
                    isOpen={searchOpen}
                    onClose={() => setSearchOpen(false)}
                    onSearch={handleSearch}
                />
            </>
        )
    }


    function Logo() {
        return (
            <a href='#!' className="logo">
                <span>
                    <img src="../assets/images/logo/logo.svg" alt="logo-large" className="logo-lg" />
                </span>
            </a>
        )
    }

    return (
        <div className="topbar">
            <div className="topbar-left" style={{ marginLeft: openMenu ? 0 : 70, width: openMenu ? 240 : 230 }}>
                <Logo />
            </div>
            <nav className="navbar-custom">
                <ul className="list-unstyled topbar-nav float-right mb-0">
                    {/* <Notificacao /> */}
                    <MenuPerfil />
                </ul>
                <ul className="list-unstyled topbar-nav mb-0">
                    <CloseMenu />
                    <Search />
                </ul>
            </nav>

            {showLogoutModal && (
                <ModalEmpty
                    title="Confirmar Saída"
                    onClose={() => setShowLogoutModal(false)}
                    onSave={confirmSair}
                    nomeButtonSave="Sair do Sistema"
                    nomeButtonCancel="Cancelar"
                    setWidth="400px"
                >
                    <div className="p-3 text-center">
                        <Icon name="ti-alert" style={{ fontSize: '48px', color: 'var(--color-success)', marginBottom: '16px', display: 'block' }} />
                        <p style={{ margin: 0, fontSize: '16px', color: 'var(--color-text-primary)' }}>
                            Deseja realmente sair do sistema?
                        </p>
                    </div>
                </ModalEmpty>
            )}
        </div>
    )
}

export default Header